import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { dummyImage } from './image';
import { MatTableDataSource } from '@angular/material/table';
import {  SamePillIdRecord } from './../../models/drug-details';
import { RpoToolService } from '../../services/rpo-tool.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import * as constants from 'src/app/config/app-constants';

import { ImportWizardAlertComponent } from '../import-wizard-alert/import-wizard-alert.component';
import { RemovePillId } from '../../models/drug';
import { HttpErrorResponse } from '@angular/common/http';
import {  Image } from '../../models/drug-details';


@Component({
  selector: 'app-import-wizard-pill-id-details',
  standalone: false,
  templateUrl: './import-wizard-pill-id-details.component.html',
  styleUrl: './import-wizard-pill-id-details.component.scss'
})

export class ImportWizardPillIdDetailsComponent implements OnInit{
  isChangePillIdShow: boolean = false;
  defaultImage = dummyImage;
  pillId? : number;
  changePillId? : number;
  ndc : string;
  drugName: string;
  dataSourceId: number;
  samePilldrugs = new MatTableDataSource<SamePillIdRecord>();
  removePillModel: RemovePillId;
  images: Image = {};

  constructor(
    public dialogRef: MatDialogRef<ImportWizardPillIdDetailsComponent>,
     public dialog: MatDialog,
     private rpoService: RpoToolService,
     private ngxLoader: NgxUiLoaderService,
     private toastService: ToastService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data:any
     ) {
        this.samePilldrugs = data.dataSourcePill;
        this.pillId = data.pillId;
        this.ndc = data.ndc;
        this.dataSourceId = data.dataSourceId;
        this.drugName = data.drugName;
        this.images = data.images;
      }




  ngOnInit(): void {
  }
  
  addNewPillID() {
    // Implement add functionality
  }

  changePillID() {
    this.isChangePillIdShow = !this.isChangePillIdShow;
  }

  changeOrRemovePillID() {      
      this.ngxLoader.start();
      this.rpoService
        .changeOrRemovePillId(this.ndc, this.dataSourceId, this.removePillModel)
        .subscribe(
          (result) => {
            this.ngxLoader.stop();
            if (result.statusCode === 200) {
              this.toastService.openToast(
                result.message,
                constants.ToastPanelType.done,
                2
              );
            } else {
              this.toastService.openToast(
                result.message,
                constants.ToastPanelType.error,
                2
              );
            }
          },
          (error: HttpErrorResponse) => {
            this.ngxLoader.stop();
            console.log(error);
            this.toastService.openToast(error.error.message === undefined ?
              'Something went wrong!!' : error.error.message,
              constants.ToastPanelType.error,
              2
            );
          }
        );
    }

    getPillIdByNdc(ndc : string) {      
      this.ngxLoader.start();
      console.log('after enter press' + ndc)
      this.rpoService
        .getPillIdByNdc(ndc, this.dataSourceId)
        .subscribe(
          (result) => {
            this.ngxLoader.stop();
            if (result.statusCode === 200) {
              this.changePillId = result.data;
             
            } else {
              this.toastService.openToast(
                result.message,
                constants.ToastPanelType.error,
                2
              );
            }
          },
          (error: HttpErrorResponse) => {
            this.ngxLoader.stop();
            console.log(error);
            this.toastService.openToast(error.error.message === undefined ?
              'Something went wrong!!' : error.error.message,
              constants.ToastPanelType.error,
              2
            );
          }
        );
    }

  openAlertWindowForRemove() {
    console.log("openAlertWindowForRemove() called");
      const dialogRef = this.dialog.open(ImportWizardAlertComponent, {
        backdropClass: ['smDialog'],
        disableClose: true,
        data: {
          alertIcon: "/assets/img/icons/ico.16.warning.svg",
          title: "Remove pill Id",
          bodyMessage: "Are you sure you want to Remove pill Id for this drug?",
          bodyMessage2: "",
          cancelBtnText: "Cancel",
          confirmBtnText: "Remove",
          confirmButtonColor: "btn-light-blue",
          cancelButtonColor: "btn-light-red",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.data) {
          console.log("result.data",result.data);
          this.removePillModel = {
            pillId: 0
          };
          this.changeOrRemovePillID();
        } else {
        }
      });
    }

  

    findPillIdByNdc(event: KeyboardEvent): void {
      const ndc = (event.target as HTMLInputElement).value;      
      console.log('Enter key pressed with value:', ndc);
      this.getPillIdByNdc(ndc);

    }

    

    openAlertWindowForEdit() {
      const dialogRef = this.dialog.open(ImportWizardAlertComponent, {
        backdropClass: ['smDialog'],
        disableClose: true,
        data: {
          alertIcon: "/assets/img/icons/ico.16.warning.svg",
          title: "Change pill Id",
          bodyMessage: "Are you sure you want to Change pill Id for this drug?",
          bodyMessage2: "",
          cancelBtnText: "Cancel",
          confirmBtnText: "Edit",
          confirmButtonColor: "btn-light-blue",
          cancelButtonColor: "btn-light-red",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.data) {
          console.log(" change pill id", result);
          this.removePillModel = {
            pillId: this.changePillId
          };

          this.changeOrRemovePillID();
        } else {
        }
      });
    }


}
